import { lazyWithPreload as lazy } from 'react-lazy-with-preload';

const ClassicSupply = {
  Content: lazy(
    () =>
      import(
        'components/direct-sales/classic-supply/components/ClassicSupplyContent'
      )
  ),
  Template: lazy(() => import('components/app/routes/NonRevampScreenTemplate'))
};

export default ClassicSupply;
